/**
 * Member Testimonials Swiper
 * Implements Swiper.js for member testimonials with 1 slide on mobile, 2 on desktop
 */

import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

class MemberTestimonialsSwiper {
    constructor() {
        this.swiperInstance = null;
        this.init();
    }

    init() {
        const container = document.querySelector('.member-testimonials-swiper');

        if (!container) {
            return;
        }

        this.container = container;
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperInstance || !this.container) {
            return;
        }

        this.swiperInstance = new Swiper(this.container, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            grabCursor: true,
            simulateTouch: true,
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Navigation
            navigation: {
                nextEl: '.testimonials-nav-next',
                prevEl: '.testimonials-nav-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // Desktop (768px and up) - 2 slides
                768: {
                    slidesPerView: 2,
                }
            }
        });
    }

    destroySwiper() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    }
}

export default MemberTestimonialsSwiper;